import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { clearAuth } from '@/store/slices/authSlice';
import { tokenService } from '@/utils/tokenService';

const baseQuery = fetchBaseQuery({
  baseUrl: import.meta.env.VITE_API_BASE_URL || '/api',
  credentials: 'include',
  prepareHeaders: (headers) => {
    const token = tokenService.getAccessToken();

    if (token) {
      headers.set('authorization', `Bearer ${token}`);
    }

    headers.set('accept', 'application/json');
    return headers;
  },
});

const baseQueryWithAuth = async (args: any, api: any, extraOptions: any) => {
  let result = await baseQuery(args, api, extraOptions);

  if (result.error && result.error.status === 401) {
    tokenService.clear();
    api.dispatch(clearAuth());
  }

  return result;
};

export const apiSlice = createApi({
  reducerPath: 'api',
  baseQuery: baseQueryWithAuth,
  tagTypes: [
    'User',
    'CommunityPartners',
    'Auth',
    'FeatureFlags',
    'PaymentRequest',
    'BankAccount',
    'UpiAccount',
    'Accounts',
    'rwa',
    'Assets',
    'Notification',
    'Kyc',
    'Coupon',
    'Vendors',
    'Contestants',
    'Voting',
    'Nft',
    'Live',
  ],
  endpoints: () => ({}),
});

export const {
  util: { getRunningQueriesThunk },
} = apiSlice;

export default apiSlice;
